import ResourceManager from "@/components/admin/ResourceManager";
import { Field, ImageUploader, TextArea, Toggle } from "@/components/admin/Primitives";

export default function Events() {
  return (
    <ResourceManager
      resource="events"
      title="Events"
      subtitle="Tournaments, parties, camps and matches."
      defaults={{ title: "", slug: "", description: "", event_type: "tournament", start_date: new Date().toISOString().slice(0, 16), end_date: "", venue: "PlayZone Arena", price: "", image_url: "", is_featured: false, is_published: true }}
      columns={[
        { key: "image_url", label: "Image" },
        { key: "title", label: "Title" },
        { key: "event_type", label: "Type" },
        { key: "start_date", label: "Starts", render: (r) => new Date(r.start_date).toLocaleDateString() },
        { key: "is_published", label: "Published" },
      ]}
      renderForm={(form, setForm) => (
        <>
          <Field label="Title" value={form.title} onChange={(v) => setForm({ ...form, title: v })} required testid="event-title" />
          <Field label="Slug (auto if empty)" value={form.slug} onChange={(v) => setForm({ ...form, slug: v })} testid="event-slug" />
          <TextArea label="Description" rows={5} value={form.description} onChange={(v) => setForm({ ...form, description: v })} required testid="event-description" />
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-bold mb-1">Type</label>
              <select value={form.event_type} onChange={(e) => setForm({ ...form, event_type: e.target.value })} data-testid="event-type" className="w-full px-4 py-3 rounded-2xl border-2 border-slate-200 focus:border-orange-500 outline-none">
                <option value="tournament">Tournament</option>
                <option value="party">Party</option>
                <option value="camp">Camp</option>
                <option value="match">Match</option>
              </select>
            </div>
            <Field label="Price (display)" value={form.price} onChange={(v) => setForm({ ...form, price: v })} testid="event-price" placeholder="LKR 12,000 / team" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Start date" type="datetime-local" value={form.start_date?.slice(0,16)} onChange={(v) => setForm({ ...form, start_date: v })} required testid="event-start" />
            <Field label="End date" type="datetime-local" value={form.end_date?.slice(0,16)} onChange={(v) => setForm({ ...form, end_date: v })} testid="event-end" />
          </div>
          <Field label="Venue" value={form.venue} onChange={(v) => setForm({ ...form, venue: v })} testid="event-venue" />
          <ImageUploader value={form.image_url} onChange={(v) => setForm({ ...form, image_url: v })} testid="event-image" />
          <div className="flex gap-6">
            <Toggle label="Featured" checked={form.is_featured} onChange={(v) => setForm({ ...form, is_featured: v })} testid="event-featured" />
            <Toggle label="Published" checked={form.is_published} onChange={(v) => setForm({ ...form, is_published: v })} testid="event-published" />
          </div>
        </>
      )}
    />
  );
}
